import { ImageWithFallback } from '../../components/home/ImageWithFallback';
import { Users, BookOpen, Heart, Award, Target, Eye, Lightbulb } from 'lucide-react';
import { Card } from '../../components/ui/card';
import welcomeImage from '../../assets/img/HomePage/welcome-image.jpeg';

const AboutUsComponent = () => {
    const features = [
        {
            icon: Users,
            title: 'Community Building',
            description: 'Fostering strong bonds among members through regular gatherings and cultural programs.',
        },
        {
            icon: BookOpen,
            title: 'Cultural Heritage',
            description: 'Preserving and promoting our rich traditions, language, and spiritual practices.',
        },
        {
            icon: Heart,
            title: 'Social Welfare',
            description: 'Supporting members through educational scholarships, healthcare assistance, and community aid.',
        },
        {
            icon: Award,
            title: 'Excellence',
            description: 'Recognizing and celebrating achievements of community members in various fields.',
        },
    ];

    const objectives = [
        {
            icon: Target,
            title: 'Our Mission',
            description: 'To preserve and promote the cultural heritage and values of the Brahmin community while fostering unity, social welfare, and educational advancement among our members.',
        },
        {
            icon: Eye,
            title: 'Our Vision',
            description: 'To be a leading community organization that bridges tradition and modernity, empowering members to excel in all spheres of life while maintaining our cultural identity.',
        },
        {
            icon: Lightbulb,
            title: 'Our Values',
            description: 'Integrity, Unity, Cultural Pride, Social Responsibility, Educational Excellence, and Inclusive Growth are the core values that guide all our initiatives and programs.',
        },
    ];

    const timeline = [
        { year: '1985', event: 'text goes here...' },
        { year: '1990', event: 'text goes here...' },
        { year: '2000', event: 'text goes here...' },
        { year: '2010', event: 'text goes here...' },
        { year: '2015', event: 'text goes here...' },
        { year: '2020', event: 'text goes here...' },
        { year: '2025', event: 'text goes here...' },
    ];

    return (
        <div className="pt-40">
            {/* Hero Section */}
            <section className="relative py-20 bg-gradient-to-br from-[#060771] to-[#BF1A1A] text-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        {/* <div className="inline-block px-4 py-2 bg-[#FFE08F] rounded-full mb-6">
                            <span className="text-[#060771]">ಕಾರ್ಯಕ್ರಮಗಳು</span>
                        </div> */}
                        <h1 className="text-4xl md:text-5xl lg:text-6xl mb-6">
                            ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ
                        </h1>
                        <p className="text-xl md:text-2xl text-white/90">
                            ವೇದ -ಧರ್ಮ -ಸಂಸ್ಕೃತಿ -ನಿತ್ಯ ಸೇವೆಯ ಹಾದಿ
                        </p>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div>
                            <p className="text-gray-700 mb-4">
                                ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭೆ —1970ರ ದಶಕದಲ್ಲಿ ಪ್ರಾರಂಭವಾದ ಸಂಘ ಸಣ್ಣಪುಟ್ಟ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಮಾಡಿಕೊಂಡು ಇಂದು ಮಾದರಿ ಸಂಘವಾಗಿ ಬೆಳೆದದ್ದು ಒಂದು ಇತಿಹಾಸ.  ಐವತ್ತು ವರ್ಷಗಳ ಸುದೀರ್ಘ ಕಾಲದಲ್ಲಿ ಈ ಮಹಾಸಭೆ ಧಾರ್ಮಿಕ, ಶೈಕ್ಷಣಿಕ ಮತ್ತು ಸಾಮಾಜಿಕ ಕ್ಷೇತ್ರಗಳಲ್ಲಿ ತೊಡಗಿಸಿಕೊಂಡಿದೆ.
                            </p>
                            <p className="text-gray-700 mb-4">
                                2015 ರಿಂದ ಸಂಘವು ಅನೇಕ ಧಾರ್ಮಿಕ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಮಾಡಿಕೊಂಡು ಬಂದಿದ್ದು ಒಂದು ಇತಿಹಾಸ. ಅದರಲ್ಲಿ
                                1) ದಶಲಕ್ಷ ಗಾಯತ್ರಿ ಜಪ ಯಜ್ಞ <br />
                                2) ಕೋಟಿ ರುದ್ರ ಪಾರಾಯಣ<br />
                                3) ಪರ್ಜನ್ಯ ಹೋಮ ಮತ್ತು ಜಪ<br />
                                4) ಅರುಣ ಹೋಮ<br />
                                5)ತಾಲ್ಲೂಕಿನ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳ ವಿವರಗಳನ್ನೊಳಗೊಂಡ ಡೈರಿ ಬಿಡುಗಡೆ.<br />
                                6)ಮೊಟ್ಟ ಮೊದಲ ಬಾರಿ ಬ್ರಾಹ್ಮಣ ಸಂಘದ ವತಿಯಿಂದ ರಾಜ್ಯೋತ್ಸವ ಆಚರಣೆ.<br />
                                7)ಪ್ರತಿ ವರ್ಷ ಕ್ಯಾಲೆಂಡರ್ ಬಿಡುಗಡೆ<br />
                                8)ಸುಮಾರು 15 ವರ್ಷಗಳಿಂದ ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ.<br />
                                9)ಪ್ರತಿ ವರ್ಷ ವಿಪ್ರರಿಗೆ ಮಾಘ ಸ್ನಾನದ ಪ್ರವಾಸ<br />
                                10)ಸಂಘದ ಕಾರ್ಯಾಲಯ ಉದ್ಘಾಟನೆ<br />
                                11)ಶಂಕರ ಮಠದಲ್ಲಿ ಮಹಾ ರುದ್ರಪಾರಾಯಣ<br />
                                12) ಬೆಂಗಳೂರಿನಲ್ಲಿ AKBMS ವತಿಯಿಂದ ನಡೆದ ಸುವರ್ಣಮಹೋತ್ಸವ  "ವಿಶ್ವಾಮಿತ್ರ" ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಸಂಘದಿಂದ 200 ವಿಪ್ರರಿಂದ ಹಾಜರಾತಿ.<br />
                                13) ಬೆಂಗಳೂರಿನಲ್ಲಿ AKBMS ವತಿಯಿಂದ ನಡೆದ 3ನೇ ರಾಜ್ಯಮಟ್ಟದ ಮಹಿಳಾ ಸಮ್ಮೇಳನಕ್ಕೆ "ಅಭಿಜಾತೆ" ಗೆ ಚಿಂತಾಮಣಿಯಿಂದ ಹಾಜರಾತಿ.<br />
                                ಸಂಘದ ಕಾರ್ಯಾಲಯದಲ್ಲಿ  ವೇದಪಾಠ ಪ್ರಾರಂಭವಾಗಿದ್ದು  ಪ್ರತಿದಿನ ಸುಮಾರು 35 ಮಂದಿ ವೇದಪಾಠವನ್ನು ಕಲಿಯುತ್ತಿದ್ದಾರೆ.<br />
                                14)ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ತಾಲ್ಲೂಕಿನ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳ ಡೈರೆಕ್ಟರಿ ಬಿಡುಗಡೆ
                            </p>
                            <p className="text-gray-700 mb-4">
                                ಮುಂದೆಯೂ ಅನೇಕ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಸಂಘದ ವತಿಯಿಂದ ಹಮ್ಮಿಕೊಳ್ಳಲು ಉದ್ದೇಶಿಸಲಾಗಿದೆ. ಮುಖ್ಯವಾಗಿ ಆರೋಗ್ಯ, ಸಾಮಾಜಿಕ, ಮತ್ತು ಶೈಕ್ಷಣಿಕವಾಗಿ ಸಮಾಜದ ಒಳತಿಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ನಿರ್ಧರಿಸಲಾಗಿದೆ. ಇದಕ್ಕೆ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳು ಸಹಕಾರ ನೀಡಲು  ವಿನಮ್ರವಾಗಿ ಕೋರುತ್ತೇವೆ.
                            </p>
                        </div>
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 w-full h-full bg-gradient-to-br from-[#800000] to-[#F59E0B] rounded-lg"></div>
                            <ImageWithFallback
                                src={welcomeImage}
                                className="relative rounded-lg shadow-xl w-full h-[400px] object-cover"
                            />
                        </div>
                    </div>

                    {/* Timeline */}
                    <div className="bg-gray-50 rounded-lg p-8 md:p-12">
                        <div className="text-center mb-12">
                            <h2 className="text-4xl text-[#4A0404] mb-4">ನಮ್ಮ ಪ್ರಯಾಣ</h2>
                            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                                ನಮ್ಮ ಪ್ರಯಾಣದ ಸಂಕ್ಷಿಪ್ತ ಪರಿಚಯ —
                            </p>
                        </div>
                        <div className="relative">
                            {/* Timeline line */}
                            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-[#800000] to-[#F59E0B]"></div>

                            <div className="space-y-8">
                                {timeline.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`flex items-center gap-8 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                                            }`}
                                    >
                                        <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                                            <Card className="p-6 hover:shadow-lg transition-shadow">
                                                <span className="inline-block px-3 py-1 bg-[#800000] text-white rounded-full mb-2">
                                                    {item.year}
                                                </span>
                                                <p className="text-gray-700">{item.event}</p>
                                            </Card>
                                        </div>
                                        <div className="hidden md:flex w-4 h-4 rounded-full bg-[#F59E0B] border-4 border-white shadow-lg z-10"></div>
                                        <div className="flex-1"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default AboutUsComponent;